/**
 * Debounce function to excute a callback when the time comes
 * @param  {Function} callback               a callback function
 * @param  {number}   wait                   time to wait in milliseconds
 * @return {Function}            closure containing a future execution of the callback function
 */
export const useDebounce = <T extends unknown[]>(
  callback: (...args: T) => void,
  wait: number,
): ((...args: T) => void) => {
  let timeout: ReturnType<typeof setTimeout> | null = null;
  return (...args: T) => {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => callback(...args), wait);
  };
};
